import { useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import type { VirtualVehicleQuery, VirtualVehicleVehicleList } from '@/@types/VirtualVehicle';
import type { RequestState } from '../../@types/RequestState';
import { getGql } from '../../fetch';

const GET_VIRTUAL_VEHICLES = gql`
  query vehicles($branchID: ID!) {
    vehicles(branchID: $branchID) {
      vehicles {
        id
        market
        manufacturer
        salesName
        modelName
        modelSeries
        modelYear
        gearboxType
        fuelType
        enginePower
        chassis
        drivingWheel
        segment
        seats
        environmentClass
        co2
        batteryCapacity
        electricalRangeWLTP
        expireDate
        retailerPrice
        manufacturerConfigurationId
      }
    }
  }
`;

export const VIRTUAL_VEHICLES_QUERY_KEY = 'virtual-vehicles';

const useVirtualVehicles = (
  branchId: string,
): [VirtualVehicleVehicleList | undefined, RequestState] => {
  const { data, isLoading, isFetching, isSuccess, isError } = useQuery<VirtualVehicleQuery>({
    queryKey: [VIRTUAL_VEHICLES_QUERY_KEY, branchId],
    queryFn: async ({ signal }) =>
      getGql<VirtualVehicleQuery>(
        `${process.env.NEXT_PUBLIC_VIRTUAL_VEHICLE_URI}/graphql`,
        GET_VIRTUAL_VEHICLES,
        { branchID: branchId },
        signal,
      ),
    placeholderData: (prev) => prev,
    enabled: !!branchId,
  });

  return [data?.vehicles ?? undefined, { isLoading, isFetching, isSuccess, isError }];
};

export default useVirtualVehicles;
